import { CustomAction } from '../../generalTypes';
import {
  DEQUEUE_SHEET,
  ENQUEUE_SHEET,
  DEQUEUE_ALL_SHEETS,
} from '../actionConstants';
import { SheetObject } from './sheetTypes';

export const actionEnqueueSheet = (
  sheet: SheetObject
): CustomAction<{ sheet: SheetObject }> => ({
  type: ENQUEUE_SHEET,
  payload: {
    sheet,
  },
});
export const actionDequeueSheet = () => ({
  type: DEQUEUE_SHEET,
});

export const actionDequeueAllSheets = () => ({ type: DEQUEUE_ALL_SHEETS });
